// 这里保存的是库级别的可变运行时状态，只用于控制迭代次数和调试日志。
module.exports = {
  printIntervalInfo: false,
  maxIterations: 99999,
};
